// BuildingDetailsAppliancesAddAppliance.js
import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const applianceOptions = ["refrigerator", "oven", "microwave", "dishwasher", "washing_machine"];

const BuildingDetailsAppliancesAddAppliance = ({ buildingId, appliance, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        appliance_type: '',
        annual_energy_kwh: '',
        power_watts: '',
        weekly_usage_hours: '',
        cycles_per_week: '',
        hours_per_cycle: ''
    });

    useEffect(() => {
        if (appliance) {
            setFormData({
                appliance_type: appliance.appliance_type,
                annual_energy_kwh: appliance.annual_energy_kwh || '',
                power_watts: appliance.power_watts || '',
                weekly_usage_hours: appliance.weekly_usage_hours || '',
                cycles_per_week: appliance.cycles_per_week || '',
                hours_per_cycle: appliance.hours_per_cycle || ''
            });
        }
    }, [appliance]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            annual_energy_kwh: formData.annual_energy_kwh ? parseFloat(formData.annual_energy_kwh) : null,
            power_watts: formData.power_watts ? parseFloat(formData.power_watts) : null,
            weekly_usage_hours: formData.weekly_usage_hours ? parseFloat(formData.weekly_usage_hours) : null,
            cycles_per_week: formData.cycles_per_week ? parseInt(formData.cycles_per_week) : null,
            hours_per_cycle: formData.hours_per_cycle ? parseFloat(formData.hours_per_cycle) : null,
            building: parseInt(buildingId)
        };

        const url = appliance
            ? `/buildings/${buildingId}/appliances/${appliance.id}/`
            : `/buildings/${buildingId}/appliances/`;

        const method = appliance ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    const renderConditionalFields = () => {
        const type = formData.appliance_type;
        switch (type) {
            case "refrigerator":
                return (
                    <TextField
                        label="Annual Energy (kWh)"
                        name="annual_energy_kwh"
                        type="number"
                        inputProps={{ min: 0 }}
                        fullWidth
                        value={formData.annual_energy_kwh}
                        onChange={handleChange}
                    />
                );
            case "oven":
            case "microwave":
                return (
                    <>
                        <TextField
                            label="Power (Watts)"
                            name="power_watts"
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            value={formData.power_watts}
                            onChange={handleChange}
                        />
                        <TextField
                            label="Weekly Usage Hours"
                            name="weekly_usage_hours"
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            value={formData.weekly_usage_hours}
                            onChange={handleChange}
                        />
                    </>
                );
            case "dishwasher":
            case "washing_machine":
                return (
                    <>
                        <TextField
                            label="Power (Watts)"
                            name="power_watts"
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            value={formData.power_watts}
                            onChange={handleChange}
                        />
                        <TextField
                            label="Cycles per Week"
                            name="cycles_per_week"
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            value={formData.cycles_per_week}
                            onChange={handleChange}
                        />
                        <TextField
                            label="Hours per Cycle"
                            name="hours_per_cycle"
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            value={formData.hours_per_cycle}
                            onChange={handleChange}
                        />
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {appliance ? 'Edit Appliance' : 'Add Appliance'}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    select
                    label="Appliance Type"
                    name="appliance_type"
                    value={formData.appliance_type}
                    onChange={handleChange}
                    required
                    fullWidth
                    disabled={!!appliance}
                >
                    {applianceOptions.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                        </MenuItem>
                    ))}
                </TextField>

                {renderConditionalFields()}

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" type="submit">
                        {appliance ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsAppliancesAddAppliance;
